import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import { normalize, schema } from 'normalizr';

import {
  CLEAR_AUTH,
  COMPLETE_INFO,
  LOGIN,
  RECOVER_PASSWORD,
  RESET_PASSWORD,
  SET_COMPANY,
  SET_SUBCOMPANY,
  VERIFY_TOKEN,
  LOAD_SESSION,
} from 'auth/constants';

const role = new schema.Entity('roles');
const userCompanies = new schema.Entity('userCompanies', { role });

export const loginPending = (state) => ({
  ...state,
  message: null,
  isLoading: true,
  isAuthenticated: false,
});

export const loginFulfilled = (state, { payload: { user, token, message } }) => {
  const normalized = normalize({ companies: user.companies }, { companies: [userCompanies] });
  return {
    ...state,
    user,
    ...normalized,
    token,
    message,
    isLoading: false,
    isAuthenticated: true,
  };
};

export const loginRejected = (state, { payload: { message } }) => ({
  ...state,
  message,
  isLoading: false,
  isAuthenticated: false,
});

export const recoverPasswordPending = (state) => ({
  ...state,
  message: null,
  isLoading: true,
});

export const recoverPasswordFulfilled = (state, { payload: { message } }) => ({
  ...state,
  message,
  isLoading: false,
});

export const recoverPasswordRejected = (state, { payload: { message } }) => ({
  ...state,
  message,
  isLoading: false,
});

export const resetPasswordPending = (state) => ({
  ...state,
  message: null,
  isLoading: true,
});

export const resetPasswordFulfilled = (state, { payload: { message } }) => ({
  ...state,
  message,
  isLoading: false,
});

export const resetPasswordRejected = (state, { payload: { message } }) => ({
  ...state,
  message,
  isLoading: false,
});

export const completeInfoPending = (state) => ({
  ...state,
  message: null,
  isLoading: true,
});

export const completeInfoFulfilled = (state, { payload: { message } }) => ({
  ...state,
  message,
  isLoading: false,
});

export const completeInfoRejected = (state, { payload: { message } }) => ({
  ...state,
  message,
  isLoading: false,
});

export const verifyTokenPending = (state) => ({
  ...state,
  message: null,
  isLoading: true,
});

export const verifyTokenFulfilled = (state, { payload: { user, message } }) => {
  const normalized = normalize({ companies: user.companies }, { companies: [userCompanies] });
  return {
    ...state,
    user,
    ...normalized,
    message,
    isLoading: false,
    isAuthenticated: true,
  };
};

export const verifyTokenRejected = (state, { payload: { message } }) => ({
  ...state,
  message,
  isLoading: false,
  isAuthenticated: false,
});

export const reset = (state) => ({ ...initialState, isAuthenticated: false });

export const setCompany = (state, { payload: company }) => ({ ...state, company });
export const setSubcompany = (state, { payload: subcompany }) => ({
  ...state,
  subcompany,
});

export const initialState = {
  token: null,
  user: null,
  isLoading: false,
  message: null,
  isAuthenticated: true,
  entities: {},
  result: {},
  company: null,
  subcompany: null,
};

export const loadSession = (state, { payload: { user, token } }) => {
  const normalized = normalize({ companies: user.companies }, { companies: [userCompanies] });
  return {
    ...state,
    user,
    isAuthenticated: true,
    ...normalized,
    token,
  };
};

const authReducers = {
  [LOGIN]: {
    [PENDING]: loginPending,
    [REJECTED]: loginRejected,
    [FULFILLED]: loginFulfilled,
  },
  [RECOVER_PASSWORD]: {
    [PENDING]: recoverPasswordPending,
    [REJECTED]: recoverPasswordRejected,
    [FULFILLED]: recoverPasswordFulfilled,
  },
  [RESET_PASSWORD]: {
    [PENDING]: resetPasswordPending,
    [REJECTED]: resetPasswordRejected,
    [FULFILLED]: resetPasswordFulfilled,
  },

  [VERIFY_TOKEN]: {
    [PENDING]: verifyTokenPending,
    [REJECTED]: verifyTokenRejected,
    [FULFILLED]: verifyTokenFulfilled,
  },
  [COMPLETE_INFO]: {
    [PENDING]: completeInfoPending,
    [REJECTED]: completeInfoRejected,
    [FULFILLED]: completeInfoFulfilled,
  },
  [CLEAR_AUTH]: reset,
  [SET_COMPANY]: setCompany,
  [SET_SUBCOMPANY]: setSubcompany,
  [LOAD_SESSION]: loadSession,
};

export default TypeToReducer(authReducers, initialState);



// WEBPACK FOOTER //
// src/modules/auth/reducers/auth_reducers.js